import { Flex, theme, Typography } from '@styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DescriptionCard = () => {
  const { i18n } = useTranslation();

  return (
    <Flex mb={24} position="relative">
      <Flex
        background={theme.colors.white[100]}
        height="100%"
        opacity={0.04}
        position="absolute"
        width="100%"
      />
      <Flex backdropFilter="blur(17px)" flexDirection="column" gap={8} p={24}>
        <Typography
          color={theme.colors.white[100]}
          variant="MS-semibold-s20-lh25"
        >
          {i18n.t('OfflinePage.Title')}
        </Typography>
        <Typography
          color={theme.colors.white[100]}
          opacity={0.8}
          variant="MS-bold-s14-lh22"
        >
          {i18n
            .t('OfflinePage.Description.array', { returnObjects: true })
            .map((word, index) =>
              index % 2 === 0 ? (
                word
              ) : (
                <span
                  key={index}
                  style={{
                    color: theme.colors.galliano,
                  }}
                >
                  {word}
                </span>
              )
            )}
        </Typography>
      </Flex>
    </Flex>
  );
};

export default DescriptionCard;
